export const INITIAL_STATE = {
  modal: {
    content: null,
  },
  imgViewer: '',
};
